export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1605164598708-25701594473e?crop=entropy&cs=srgb&fm=jpg&q=90&w=2400",
  foamWash: "https://images.unsplash.com/photo-1761312834150-4beefff097a7?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  polish: "https://images.unsplash.com/photo-1771491237209-b89bc7290588?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  wheel: "https://images.unsplash.com/photo-1565689876697-e467b6c54da2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  interior: "https://images.unsplash.com/photo-1609250687610-95d4f56261a6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  dash: "https://images.unsplash.com/photo-1771491237225-01931a752f58?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};

export const NAV_LINKS = [
  { label: "Services", href: "#services" },
  { label: "Ethos", href: "#ethos" },
  { label: "Areas", href: "#areas" },
  { label: "FAQ", href: "#faq" },
  { label: "Book", href: "#booking" },
];

export const MANIFESTO = [
  {
    n: "01",
    title: "You Deal With The Owner",
    body: "No rotating crews or call centers. You book with me, I show up, and I treat every vehicle like it's my own — start to finish.",
  },
  {
    n: "02",
    title: "Honest Advice",
    body: "If your car needs a little extra time, we take it. If it doesn't need a service, we'll tell you. You only pay for what actually helps.",
  },
  {
    n: "03",
    title: "We Come To You",
    body: "Being fully mobile means we bring the whole setup to your driveway. Less hassle for you, and a solid result without a trip to a shop.",
  },
];

export const TIME_SLOTS = [
  "08:00 AM", "09:00 AM", "10:00 AM", "11:00 AM", "12:00 PM", "01:00 PM",
  "02:00 PM", "03:00 PM", "04:00 PM", "05:00 PM", "06:00 PM", "07:00 PM",
];

export const VEHICLE_SIZES = [
  { value: "sedan", label: "Car / Sedan", surcharge: 0 },
  { value: "van", label: "Van", surcharge: 25 },
  { value: "suv_truck", label: "SUV / Truck", surcharge: 50 },
];
